import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

import { DesktopLogoIcon } from './DesktopLogoIcon';
import { MobileLogoIcon } from './MobileLogoIcon';

export const LogoAnchor = styled.a`
    display: flex;
    align-items: center;
    height: 100%;
    color: ${getPurpurColor('brandCorePurple')};
    border-top: ${getPurpurBorder('widthSm')} solid transparent;
    border-bottom: ${getPurpurBorder('widthSm')} solid transparent;

    ${purpurFocus()};

    ${purpurMedia('md')`
        padding: ${getPurpurSpacing('100')} 0 ${getPurpurSpacing('150')};
    `};

    &:hover {
        color: ${getPurpurColor('textInteractivePrimary')};
        border-bottom-color: ${getPurpurColor('borderInteractivePrimaryHover')};
    }

    &:active {
        color: ${getPurpurColor('textInteractivePrimaryHover')};
        border-bottom-color: transparent;
    }

    &:focus {
        color: ${getPurpurColor('brandCorePurple')};
    }
`;

export const LogoImage = styled(DesktopLogoIcon)`
    width: auto;
    height: 2rem;
    display: none;

    ${purpurMedia('md')`
        display: block;
    `};
`;

export const LogoImageSmall = styled(MobileLogoIcon)`
    display: block;
    width: auto;
    height: 2rem;

    ${purpurMedia('md')`
        display: none;
    `};
`;
